/**
 * Cierra submenús del header-drawer al pulsar “atrás” (sin depender del minificado de global).
 */
document.addEventListener('click', function (event) {
  var brandViewAll = event.target.closest('.megamenu-brand-viewall')
  if (brandViewAll) {
    event.stopPropagation()
    return
  }

  var back = event.target.closest('.menu-drawer__submenu-back')
  if (!back) return

  var drawer = back.closest('header-drawer')
  if (!drawer) return

  var details = back.closest('details')
  var main = drawer.querySelector('details.menu-drawer-container')
  if (!details || details === main) return

  event.preventDefault()
  event.stopPropagation()

  if (typeof drawer.closeSubmenu === 'function') {
    drawer.closeSubmenu(details)
  } else {
    details.classList.remove('menu-opening')
    details.removeAttribute('open')
  }
})
